import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMultiStepForm } from '../../../ui-components/base/MultiStepForm';
import { fetchCountries } from '../../../redux/actions/commonDataActions';
import CountrySelection from '../../../components/shared/countrySelection';
import styles from './CountryTargetingStep.module.scss';

const CountryTargetingStep = ({ isEditMode = false }) => {
  const { stepData, updateStepData, setStepValid } = useMultiStepForm();
  const dispatch = useDispatch();

  const { countries = [], countriesLoading } = useSelector(state => state.commonData || {});

  const [countryList, setCountryList] = useState([]);
  const isInitializedRef = useRef(false);

  // Fetch countries if they haven't been loaded yet (e.g. remoteConfig arrived after Layout's fetch)
  useEffect(() => {
    if (countries.length === 0 && !countriesLoading) {
      dispatch(fetchCountries());
    }
  }, []);

  // Initialize country list once when countries load
  useEffect(() => {
    if (countries.length > 0 && !isInitializedRef.current) {
      const selectedCodes = stepData.selectedCountries?.map(c => c.countryCode) || [];
      const initializedList = countries.map(country => ({
        ...country,
        checked: isEditMode ? selectedCodes.includes(country.countryCode) : true,
      }));
      setCountryList(initializedList);
      isInitializedRef.current = true;
    }
  }, [countries]);

  // Update validation and stepData when countryList changes
  useEffect(() => {
    if (countryList.length > 0) {
      const selectedCountries = countryList.filter(c => c.checked);
      const isValid = selectedCountries.length > 0;
      setStepValid(isValid);
      updateStepData({ selectedCountries });
    }
  }, [countryList]);

  const handleCountrySelect = (country) => {
    const newCountryList = countryList.map((c) => {
      if (country.countryCode === c.countryCode) {
        return {
          ...c,
          checked: !c.checked,
        };
      }
      return c;
    });
    setCountryList(newCountryList);
  };

  const handleSelectAll = () => {
    const newCountryList = countryList.map((c) => ({
      ...c,
      checked: true,
    }));
    setCountryList(newCountryList);
  };

  const handleClearAll = () => {
    const newCountryList = countryList.map((c) => ({
      ...c,
      checked: false,
    }));
    setCountryList(newCountryList);
  };

  if (countriesLoading) {
    return (
      <div className={styles.container}>
        <p className={styles.loadingText}>Loading countries...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Country Targeting</h2>
        <p className={styles.description}>
          Target this Banner to the country mentioned below.
          <br/>
          <span className={styles.note}>
            Note: At least one country must be selected in Country Availability to move forward in the Create Banner wizard.
          </span>
        </p>
      </div>

      <CountrySelection
        countryList={countryList}
        handleClearAll={handleClearAll}
        handleSelectAll={handleSelectAll}
        handleCountrySelect={handleCountrySelect}
        title="Country Availability*"
        isLive={false}
      />
    </div>
  );
};

export default CountryTargetingStep;
